var map = {
	"./pr-1.png": "4e78",
	"./pr-2.png": "62fd",
	"./pr-3.png": "f3bb",
	"./pr-4.png": "6c9a",
	"./pr-5.png": "b942",
	"./pr-6.png": "9e9f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b9cf";